<div class="vis-card vis-web-margin-top-24-px">
  <div
    [attr.collapsed]="isCollapsed"
    class="vis-web-imprest-result-entry-header vis-row vis-web-margin-left-right-0 vis-web-position-relative vis-web-common-button-spinner vis-web-spinner-centered-button"
    id="resultEntry-{{index}}" (click)="loadDetails($event)">
    <vis-web-spinner [showSpinner]="loadingDetails"></vis-web-spinner>
    <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4 vis-web-margin-bottom-5-px-small">
      <div class="vis-web-flex">
        <div>
          <div *ngFor="let line of displayName.split(',')" [innerHTML]="line">
          </div>
        </div>
      </div>
    </div>
    <!-- Adresse -->
    <div class="vis-col-mobile-12 vis-col-tablet-3 vis-col-desktop-3 vis-web-margin-bottom-5-px-small">
      <div>
        <div [innerHTML]="gatekeeperAddress"></div>
        {{displayLocality}}
      </div>
    </div>
    <!-- Fachgebiet -->
    <div class="vis-col-mobile-12 vis-col-tablet-2 vis-col-desktop-2 vis-web-margin-bottom-5-px-small">
      <div>{{billerTypeDescription}}</div>
    </div>
    <!-- Modell -->
    <div class="vis-col-mobile-12 vis-col-tablet-3 vis-col-desktop-3">
      <div>
        <!-- <div>{{'imprest.resultEntry.model' | translate}}:</div>-->
        <div class="vis-web-flex-base vis-web-justify-content-space-between">
          <div class="vis-web-flex">
            <div class="vis-web-margin-right-5-px">
              <div *ngFor="let affi of networkAffiliationsInsuranceModels">
                <div class="vis-web-flex-base">
                  {{handleAffe(affi) | translate}}<!-- z.B. description of 'InsuranceModel.HMO.SHORT'-->
                </div>
              </div>
            </div>
            <div class="vis-web-position-relative">
              <vsci-icon
                class="cursor-pointer vis-web-common-svg-icon-stroke-violet-base vis-web-imprest-result-entry-header-info-icon"
                icon="my-visana-22-info-round-24-24-based"
                configClasses="size0-5x"
                [ngbPopover]="modelInfoContent"
                #p1="ngbPopover"
                container="body"
                popoverTitle="{{'txt.model' | translate}}"
                (click)="togglePopover(p1, $event)"
                [hasFlexParent]="true"
                triggers="manual"></vsci-icon>
            </div>
          </div>
          <div>
            <div class="vis-web-flex">
              <div class="vis-web-margin-right-1-px">
                <div *ngFor="let affi of networkAffiliationsPatientAdmissionFreeze; index as i"
                     class="vis-web-imprest-result-model-text">
                    <span
                      *ngIf="networkAffiliationsInsuranceModels[i] === 'InsuranceModel.COMBI_CARE' || networkAffiliationsInsuranceModels[i] === 'InsuranceModel.MED_DIRECT'; else admissionIcons">
                      <div class="vis-web-icon-third-party-container">
                        <img class="vis-web-icon-third-party-img size0-5x" src="assets/images/vis-warn.svg" />
                      </div>
                    </span>

                    <ng-template #admissionIcons>
                  <vsci-icon *ngIf="affi==='PatientAdmissionFreeze.ADMISSION_OPEN'"
                             icon="checkmark-small"
                             [meaning]="'PatientAdmissionFreeze.ADMISSION_OPEN' | translate"
                             configClasses="size0-5x">
                  </vsci-icon>
                  <vsci-icon *ngIf="affi==='PatientAdmissionFreeze.ADMISSION_DETAINED'"
                             icon="cross-small"
                             [meaning]="'PatientAdmissionFreeze.ADMISSION_DETAINED' | translate"
                             configClasses="size0-5x">
                  </vsci-icon>
                  <vsci-icon
                    *ngIf="affi!='PatientAdmissionFreeze.ADMISSION_OPEN' && affi!='PatientAdmissionFreeze.ADMISSION_DETAINED'"
                    icon="bubble"
                    [meaning]="'PatientAdmissionFreeze.ADMISSION_UNKNOWN' | translate"
                    configClasses="size0-5x">
                  </vsci-icon>
                </ng-template>
                </div>
              </div>
              <div class="vis-web-position-relative">
                <vsci-icon
                  class="cursor-pointer vis-web-common-svg-icon-stroke-violet-base vis-web-imprest-result-entry-header-info-icon"
                  configClasses="size0-5x"
                  icon="my-visana-22-info-round-24-24-based"
                  [hasFlexParent]="true"
                  container="body"
                  triggers="manual"
                  (click)="$event.preventDefault(); $event.stopImmediatePropagation()"
                  popoverTitle="{{'NetworkAffiliation.patientAdmissionState-label' | translate}}"
                  [ngbPopover]="patientAdmissionStateInfoContent"
                  #p2="ngbPopover"
                  (click)="togglePopover(p2, $event)">
                </vsci-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vis-col-mobile-12 vis-col-tablet-12 vis-col-desktop-12 vis-web-padding-left-right-0">
      <div class="vis-web-flex-base vis-web-justify-content-center">
        <vsci-icon configClasses="size0-5x"
                   class="vis-web-margin-bottom-8-px"
                   [hasFlexParent]="true"
                   [id]="'toggleDetails' + '-' + index"
                   [icon]="(isCollapsed || loadingDetails)?'linear-icons-chevron-down':'linear-icons-chevron-up'"
                   [attr.aria-expanded]="!isCollapsed"
                   aria-controls="collapseDoctor"></vsci-icon>
      </div>
    </div>
  </div>


  <!--                       -->
  <!-- Details eines Arztes. -->
  <!--                       -->
  <div
    class="vis-row vis-web-imprest-result-entry-detail vis-web-margin-left-right-0 vis-web-width-100-percent vis-web-padding-top-10-px vis-web-background-primary-white"
    *ngIf="gatekeeperDetails && !isCollapsed"
    id="{{partnerNumber}}">
    <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4">
      <div><strong>{{'common.contact.address' | translate}}</strong></div>
      <div *ngIf="surgeryName">{{surgeryName}}</div>
      <div>{{postalAddressStreet}} {{postalAddressBuildingNumber}}</div>
      <div>{{postalAddressPostalCode}} {{postalAddressLocality}}</div>
    </div>
    <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4">
      <div><strong>{{'common.contact' | translate}}</strong></div>
      <ul>
        <li *ngFor="let phoneContact of phoneContacts">
          <span>{{phoneContact[0] | translate}}:</span>
          {{phoneContact[1] | chphonenumberformat}}
        </li>
        <li *ngFor="let eMailContact of eMailContacts">
        <span>{{eMailContact[0] | translate}}:
          <a href="{{eMailContact[1]}}">{{eMailContact[1]}}</a>
        </span>
        </li>
        <li *ngFor="let internetContact of internetContacts">
        <span><!--{{internetContact[0] | translate}}:-->
          <a class="actionable"
             (click)="openUrl(ensureUrl(internetContact[1]), $event)">{{ensureDisplayUrl(internetContact[1])}}</a>
        </span>
        </li>
      </ul>
    </div>

    <!-- Links -->
    <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4">
      <div><strong>{{'common.downloadsAndLinks' | translate}}</strong></div>
      <ul>
        <li>
          <a class="actionable" id="detailsPdfLink-{{index}}" (click)="openUrl(gatekeeperDetailPdfUrl, $event)">
            {{'GatekeeperDetails.title' | translate}}</a>
        </li>
        <li *ngIf="latitude!=0">
          <a class="actionable" id="detailsMapLink-{{index}}" (click)="open(mapdialog, $event)">
            {{'imprest.resultEntry.onMap' | translate}}</a>
        </li>
      </ul>
    </div>

    <!-- Mitarbeiter
    <div *ngIf="employeesDescription && employeesDescription.length > 0"
         class="vis-col-mobile-12 vis-col-tablet-12 vis-col-desktop-12 vis-web-margin-top-10-px">
      <div><strong>{{'GatekeeperDetails.employees' | translate}}</strong></div>
      <ul>
        <ng-container *ngFor="let employee of employeesDescription">
          <li>
            {{employee}}
          </li>
        </ng-container>
      </ul>
    </div> -->
    <div *ngIf="employersDescription && employersDescription.length > 0"
         class="vis-col-mobile-12 vis-col-tablet-12 vis-col-desktop-12 vis-web-margin-top-10-px">
      <div><strong>{{'EmploymentContract.employer-label' | translate}}</strong></div>
      <ul>
        <ng-container *ngFor="let employer of employersDescription">
          <li>
            {{employer}}
          </li>
        </ng-container>
      </ul>
    </div>
  </div>

  <!--Google Maps Dialog-->
  <section>
    <ng-template #mapdialog let-closeModal="close" class="modal-lg">
      <div id="mapDialogHeader" class="modal-header vis-web-justify-content-space-between">
        <a href="https://maps.google.com/?q={{generateResultName()}}" target="_blank" class="modal-title">
          {{generateResultName()}}
        </a>
        <vsci-icon
          class="cursor-pointer"
          (click)="closeModal()"
          [hasFlexParent]="true"
          meaning="Close"
          icon="linear-icons-cross"
          configClasses="size0-75x fillBlack"
        ></vsci-icon>
      </div>
      <div id="mapDialogBody" class="modal-body vis-web-imprest-result-entry-map">
        <vis-web-google-map [latitude]="latitude"
                            [longitude]="longitude"
                            [maxZoom]="19"
                            [center]="center!"
                            [zoom]="14"
                            [scrollwheel]="true"
                            [markerIcon]="'assets/images/pin-default-48.svg'">
        </vis-web-google-map>
      </div>
    </ng-template>
  </section>
</div>

<ng-template #patientAdmissionStateInfoContent>
  <div class="vis-web-flex vis-web-flex-direction-column">
    <div class="vis-web-flex-base vis-web-margin-bottom-24-px">
      <vsci-icon icon="checkmark-small"
                 class="vis-web-margin-right-10-px"
                 [hasFlexParent]="true"
                 [meaning]="'PatientAdmissionFreeze.ADMISSION_OPEN' | translate"
                 configClasses="size0-75x"></vsci-icon>

      <div>
        {{'PatientAdmissionFreeze.ADMISSION_OPEN' | translate}}
      </div>
    </div>
    <div class="vis-web-flex-base vis-web-margin-bottom-24-px">
      <vsci-icon icon="cross-small" class="vis-web-margin-right-10-px" [hasFlexParent]="true"
        [meaning]="'PatientAdmissionFreeze.ADMISSION_DETAINED' | translate" configClasses="size0-75x fillBlack"></vsci-icon>

      <div>
        {{'PatientAdmissionFreeze.ADMISSION_DETAINED' | translate}}
      </div>
    </div>
    <div class="vis-web-flex-base">
      <!-- <vsci-icon icon="cross-small"
                 class="vis-web-margin-right-10-px"
                 [hasFlexParent]="true"
                 [meaning]="'PatientAdmissionFreeze.ADMISSION_DETAINED' | translate"
                 configClasses="size0-75x fillBlack"></vsci-icon> -->
                <div class="vis-web-icon-third-party-container vis-web-margin-right-10-px">
                  <img class="vis-web-icon-third-party-img size0-75x fillBlack" src="assets/images/vis-warn.svg" />
                </div>
      <div>
        {{'PatientAdmissionFreeze.ADMISSION_QUERY' | translate}}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modelInfoContent>
  <div [innerHTML]="'txt.model.description' | translate"></div>
</ng-template>
